/* eslint-disable */

// @ts-nocheck

// This file was automatically generated by @icp-sdk/bindgen@0.4.1.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { IDL } from '@icp-sdk/core/candid';

export const idlFactory = ({ IDL }) => {
  const CandidPrimitivesNested = IDL.Record({
    'name' : IDL.Text,
    'tags' : IDL.Vec(IDL.Text),
    'inner' : IDL.Record({ 'n' : IDL.Opt(IDL.Nat8), 'flag' : IDL.Bool }),
  });
  const CandidPrimitivesChoice = IDL.Variant({
    'none' : IDL.Null,
    'some' : IDL.Nat32,
    'word' : IDL.Text,
  });
  const CandidPrimitivesEverything = IDL.Record({
    'b' : IDL.Vec(IDL.Nat8),
    'i' : IDL.Int,
    'n' : IDL.Nat,
    'o' : IDL.Opt(IDL.Nat),
    'p' : IDL.Principal,
    'r' : CandidPrimitivesNested,
    't' : IDL.Text,
    'v' : IDL.Vec(IDL.Int),
    'i8' : IDL.Int8,
    'n8' : IDL.Nat8,
    'f32' : IDL.Float32,
    'f64' : IDL.Float64,
    'i16' : IDL.Int16,
    'i32' : IDL.Int32,
    'i64' : IDL.Int64,
    'n16' : IDL.Nat16,
    'n32' : IDL.Nat32,
    'n64' : IDL.Nat64,
    'nul' : IDL.Null,
    'res' : IDL.Reserved,
    'yes' : IDL.Bool,
    'bare' : CandidPrimitivesChoice,
    'full' : CandidPrimitivesChoice,
  });
  const CandidStrictReplyItem = IDL.Record({ 'amount' : IDL.Nat8 });
  const CandidStrictReplyReport = IDL.Record({
    'items' : IDL.Vec(CandidStrictReplyItem),
  });
  const CandidSubtypingChoice = IDL.Variant({ 'x' : IDL.Nat, 'y' : IDL.Text });
  const CandidSubtypingFull = IDL.Record({ 'a' : IDL.Nat, 'b' : IDL.Text });
  const CandidSubtypingPair = IDL.Record({
    'a' : IDL.Nat,
    'b' : IDL.Opt(IDL.Text),
  });
  const HeaderField = IDL.Tuple(IDL.Text, IDL.Text);
  const HttpRequest = IDL.Record({
    'url' : IDL.Text,
    'method' : IDL.Text,
    'body' : IDL.Vec(IDL.Nat8),
    'headers' : IDL.Vec(HeaderField),
    'certificate_version' : IDL.Opt(IDL.Nat16),
  });
  const HttpResponse = IDL.Record({
    'body' : IDL.Vec(IDL.Nat8),
    'headers' : IDL.Vec(HeaderField),
    'upgrade' : IDL.Opt(IDL.Bool),
    'status_code' : IDL.Nat16,
  });
  const HttpUpdateRequest = IDL.Record({
    'url' : IDL.Text,
    'method' : IDL.Text,
    'body' : IDL.Vec(IDL.Nat8),
    'headers' : IDL.Vec(HeaderField),
  });
  const InstallSetup = IDL.Record({
    'load_paths' : IDL.Vec(IDL.Text),
    'generation' : IDL.Nat64,
  });
  const InstallCommit = IDL.Record({
    'gems' : IDL.Vec(IDL.Text),
    'setup' : IDL.Opt(InstallSetup),
  });
  const InstallFile = IDL.Record({
    'body' : IDL.Vec(IDL.Nat8),
    'path' : IDL.Text,
  });
  const Installed = IDL.Record({
    'pending' : IDL.Opt(IDL.Nat64),
    'load_paths' : IDL.Vec(IDL.Text),
    'gems' : IDL.Vec(IDL.Text),
    'running_paths' : IDL.Vec(IDL.Text),
    'partial' : IDL.Vec(IDL.Text),
    'running' : IDL.Opt(IDL.Nat64),
  });
  
  return IDL.Service({
    'caller_compare' : IDL.Func([], [IDL.Text], []),
    'caller_remember' : IDL.Func([], [IDL.Text], []),
    'caller_whoami' : IDL.Func([], [IDL.Text], []),
    'candid_primitives_describe' : IDL.Func(
        [CandidPrimitivesEverything],
        [IDL.Text],
        [],
      ),
    'candid_primitives_echo_blob' : IDL.Func(
        [IDL.Vec(IDL.Nat8)],
        [IDL.Vec(IDL.Nat8)],
        [],
      ),
    'candid_primitives_echo_bool' : IDL.Func([IDL.Bool], [IDL.Bool], []),
    'candid_primitives_echo_float32' : IDL.Func(
        [IDL.Float32],
        [IDL.Float32],
        [],
      ),
    'candid_primitives_echo_float64' : IDL.Func(
        [IDL.Float64],
        [IDL.Float64],
        [],
      ),
    'candid_primitives_echo_int' : IDL.Func([IDL.Int], [IDL.Int], []),
    'candid_primitives_echo_int16' : IDL.Func([IDL.Int16], [IDL.Int16], []),
    'candid_primitives_echo_int32' : IDL.Func([IDL.Int32], [IDL.Int32], []),
    'candid_primitives_echo_int64' : IDL.Func([IDL.Int64], [IDL.Int64], []),
    'candid_primitives_echo_int8' : IDL.Func([IDL.Int8], [IDL.Int8], []),
    'candid_primitives_echo_nat' : IDL.Func([IDL.Nat], [IDL.Nat], []),
    'candid_primitives_echo_nat16' : IDL.Func([IDL.Nat16], [IDL.Nat16], []),
    'candid_primitives_echo_nat32' : IDL.Func([IDL.Nat32], [IDL.Nat32], []),
    'candid_primitives_echo_nat64' : IDL.Func([IDL.Nat64], [IDL.Nat64], []),
    'candid_primitives_echo_nat8' : IDL.Func([IDL.Nat8], [IDL.Nat8], []),
    'candid_primitives_echo_null' : IDL.Func([IDL.Null], [IDL.Null], []),
    'candid_primitives_echo_opt' : IDL.Func(
        [IDL.Opt(IDL.Nat)],
        [IDL.Opt(IDL.Nat)],
        [],
      ),
    'candid_primitives_echo_principal' : IDL.Func(
        [IDL.Principal],
        [IDL.Principal],
        [],
      ),
    'candid_primitives_echo_record' : IDL.Func(
        [CandidPrimitivesNested],
        [CandidPrimitivesNested],
        [],
      ),
    'candid_primitives_echo_reserved' : IDL.Func(
        [IDL.Reserved],
        [IDL.Reserved],
        [],
      ),
    'candid_primitives_echo_text' : IDL.Func([IDL.Text], [IDL.Text], []),
    'candid_primitives_echo_variant' : IDL.Func(
        [CandidPrimitivesChoice],
        [CandidPrimitivesChoice],
        [],
      ),
    'candid_primitives_echo_vec' : IDL.Func(
        [IDL.Vec(IDL.Int)],
        [IDL.Vec(IDL.Int)],
        [],
      ),
    'candid_primitives_take_empty' : IDL.Func([IDL.Empty], [IDL.Text], []),
    'candid_refusals_count' : IDL.Func([], [IDL.Nat], []),
    'candid_refusals_nums' : IDL.Func([IDL.Vec(IDL.Nat)], [IDL.Nat], []),
    'candid_refusals_small' : IDL.Func([IDL.Nat8], [IDL.Nat], []),
    'candid_refusals_text' : IDL.Func([IDL.Text], [IDL.Nat], []),
    'candid_refusals_void' : IDL.Func([IDL.Empty], [IDL.Nat], []),
    'candid_strict_reply_as_empty' : IDL.Func([], [IDL.Empty], []),
    'candid_strict_reply_as_float' : IDL.Func([], [IDL.Float64], []),
    'candid_strict_reply_as_nat' : IDL.Func([IDL.Text], [IDL.Nat], []),
    'candid_strict_reply_as_nat8' : IDL.Func([], [IDL.Nat8], []),
    'candid_strict_reply_as_principal' : IDL.Func([], [IDL.Principal], []),
    'candid_strict_reply_as_record' : IDL.Func(
        [IDL.Text],
        [IDL.Record({ 'a' : IDL.Nat8, 'b' : IDL.Opt(IDL.Text) })],
        [],
      ),
    'candid_strict_reply_as_text' : IDL.Func([], [IDL.Text], []),
    'candid_strict_reply_as_variant' : IDL.Func(
        [IDL.Text],
        [IDL.Variant({ 'ok' : IDL.Nat, 'none' : IDL.Null })],
        [],
      ),
    'candid_strict_reply_report' : IDL.Func([], [CandidStrictReplyReport], []),
    'candid_strict_reply_write_then_bad' : IDL.Func([], [IDL.Nat8], []),
    'candid_strict_reply_written' : IDL.Func([], [IDL.Bool], []),
    'candid_subtyping_choose' : IDL.Func(
        [CandidSubtypingChoice],
        [CandidSubtypingChoice],
        [],
      ),
    'candid_subtyping_full' : IDL.Func(
        [CandidSubtypingFull],
        [CandidSubtypingFull],
        [],
      ),
    'candid_subtyping_maybe' : IDL.Func(
        [IDL.Opt(IDL.Nat)],
        [IDL.Opt(IDL.Nat)],
        [],
      ),
    'candid_subtyping_narrow' : IDL.Func([IDL.Nat], [IDL.Nat], []),
    'candid_subtyping_pair' : IDL.Func(
        [CandidSubtypingPair],
        [CandidSubtypingPair],
        [],
      ),
    'candid_subtyping_two' : IDL.Func(
        [IDL.Nat, IDL.Opt(IDL.Nat)],
        [IDL.Record({ 'first' : IDL.Nat, 'second' : IDL.Opt(IDL.Nat) })],
        [],
      ),
    'candid_subtyping_widen' : IDL.Func([IDL.Int], [IDL.Int], []),
    'controller_booted_by' : IDL.Func([], [IDL.Text], []),
    'controller_guarded' : IDL.Func([], [IDL.Text], []),
    'controller_is_controller' : IDL.Func([], [IDL.Text], []),
    'count' : IDL.Func([], [IDL.Nat64], ['query']),
    'counter_main' : IDL.Func([], [IDL.Text], []),
    'declared_methods_bump' : IDL.Func([], [IDL.Text], []),
    'declared_methods_total' : IDL.Func([], [IDL.Text], []),
    'default_external_binread' : IDL.Func([], [IDL.Text], ['query']),
    'default_external_env' : IDL.Func([], [IDL.Text], ['query']),
    'default_external_read' : IDL.Func([], [IDL.Text], ['query']),
    'default_external_write' : IDL.Func([], [IDL.Text], []),
    'enumerator_main' : IDL.Func([], [IDL.Text], []),
    'fault_undoes_read' : IDL.Func([], [IDL.Text], []),
    'fault_undoes_seed' : IDL.Func([], [IDL.Text], []),
    'fault_undoes_write_then_raise' : IDL.Func([], [IDL.Text], []),
    'float_main' : IDL.Func([], [IDL.Text], []),
    'gc_lifecycle' : IDL.Func([], [IDL.Text], []),
    'gc_main' : IDL.Func([], [IDL.Text], []),
    'gc_state_main' : IDL.Func([], [IDL.Text], []),
    'http_request' : IDL.Func([HttpRequest], [HttpResponse], ['query']),
    'http_request_update' : IDL.Func([HttpUpdateRequest], [HttpResponse], []),
    'install_commit' : IDL.Func([InstallCommit], [IDL.Text], []),
    'install_put' : IDL.Func([IDL.Vec(InstallFile)], [IDL.Text], []),
    'install_remove' : IDL.Func([IDL.Text], [IDL.Text], []),
    'installed' : IDL.Func([], [Installed], ['query']),
    'persist_both_append_lines' : IDL.Func([], [IDL.Text], []),
    'persist_both_append_one' : IDL.Func([], [IDL.Text], []),
    'persist_both_check' : IDL.Func([], [IDL.Text], []),
    'persist_both_load_units' : IDL.Func([], [IDL.Text], []),
    'persist_both_rewrite_one' : IDL.Func([], [IDL.Text], []),
    'query_discards_look' : IDL.Func([], [IDL.Text], []),
    'query_discards_refuse_in_query' : IDL.Func([], [IDL.Text], ['query']),
    'query_discards_scribble' : IDL.Func([], [IDL.Text], ['query']),
    'query_discards_who' : IDL.Func([], [IDL.Text], ['query']),
    'raise_main' : IDL.Func([], [IDL.Text], []),
    'recursion_main' : IDL.Func([], [IDL.Text], []),
    'refusal_undoes_read' : IDL.Func([], [IDL.Text], []),
    'refusal_undoes_seed' : IDL.Func([], [IDL.Text], []),
    'refusal_undoes_write_then_refuse' : IDL.Func([], [IDL.Text], []),
    'require_relative_main' : IDL.Func([], [IDL.Text], []),
    'stdlib_main' : IDL.Func([], [IDL.Text], []),
    'system_time' : IDL.Func([], [IDL.Nat64], ['query']),
    'time_date' : IDL.Func([], [IDL.Text], []),
    'time_lapsed' : IDL.Func([], [IDL.Text], []),
    'time_start' : IDL.Func([], [IDL.Text], []),
    'time_tick' : IDL.Func([], [IDL.Text], []),
    'trap_text_bound_long_refusal' : IDL.Func([], [IDL.Text], []),
    'trap_text_bound_read' : IDL.Func([], [IDL.Text], []),
    'upgrade_main' : IDL.Func([], [IDL.Text], []),
    'visit' : IDL.Func([], [IDL.Nat64], []),
  });
};

export const init = ({ IDL }) => { return []; };